<template>
  <v-menu
    v-model="menuOpen"
    offset-y
    left
    :close-on-content-click="false"
    max-width="320"
    content-class="table-column-config-menu"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-if="iconOnly"
        icon
        small
        v-bind="attrs"
        v-on="on"
        title="Columns"
      >
        <v-icon small>mdi-table-cog</v-icon>
      </v-btn>
      <v-btn
        v-else
        small
        outlined
        v-bind="attrs"
        v-on="on"
        class="text-capitalize"
      >
        <v-icon left small>mdi-view-column</v-icon>
        Columns
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="subtitle-2 py-2">
        Customize columns
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="py-2">
        <p class="caption mb-2 grey--text text--darken-1">
          Drag to reorder, toggle to show or hide.
        </p>
        <draggable
          v-model="localList"
          handle=".drag-handle"
          class="column-list"
        >
          <div
            v-for="col in localList"
            :key="col.value"
            class="column-list-item d-flex align-center py-1"
          >
            <v-icon class="drag-handle mr-1" small color="grey">mdi-drag</v-icon>
            <v-checkbox
              v-model="col.visible"
              hide-details
              dense
              class="mt-0 flex-grow-1"
              :label="col.text"
            ></v-checkbox>
          </div>
        </draggable>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="py-2">
        <v-btn small text @click="reset">Reset</v-btn>
        <v-spacer></v-spacer>
        <v-btn small text @click="closeMenu">Cancel</v-btn>
        <v-btn small color="primary" @click="apply">Apply</v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  name: 'TableColumnConfigMenu',
  components: { draggable },
  props: {
    defaultHeaders: { type: Array, required: true },
    columnConfig: { type: Object, default: null },
    iconOnly: { type: Boolean, default: false }
  },
  data () {
    return {
      localList: [],
      menuOpen: false
    }
  },
  watch: {
    defaultHeaders: { handler: 'syncList', immediate: true },
    columnConfig: 'syncList'
  },
  methods: {
    buildList () {
      const config = this.columnConfig
      const byValue = new Map()
      if (config?.columns?.length) {
        config.columns.forEach(c => { byValue.set(c.value, { order: c.order, visible: c.visible !== false }) })
      }
      return this.defaultHeaders
        .map((h, index) => {
          const saved = byValue.get(h.value)
          return {
            ...h,
            order: saved != null ? saved.order : index,
            visible: saved != null ? saved.visible : true
          }
        })
        .sort((a, b) => a.order - b.order)
    },
    syncList () {
      this.localList = this.buildList()
    },
    buildPayload () {
      return {
        columns: this.localList.map((c, index) => ({
          value: c.value,
          order: index,
          visible: c.visible !== false
        }))
      }
    },
    reset () {
      this.localList = this.defaultHeaders.map((h, index) => ({ ...h, order: index, visible: true }))
      this.$emit('save', { columns: this.localList.map((c, index) => ({ value: c.value, order: index, visible: true })) })
      this.menuOpen = false
      this.$emit('close')
    },
    closeMenu () {
      this.menuOpen = false
      this.$emit('close')
    },
    apply () {
      this.$emit('save', this.buildPayload())
      this.menuOpen = false
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.column-list-item {
  min-height: 36px;
}
.drag-handle {
  cursor: grab;
}
.column-list {
  max-height: 50vh;
  overflow-y: auto;
}
</style>
